import {Acao} from "../tipos/acao";
import {
  IconArchive,
  IconBuilding, IconBuildingPlus,
  IconFilePlus,
  IconFolderDollar,
  IconHandFingerRight, IconList,
  IconPlus, IconShieldFilled,
  IconTag,
  IconThumbUp, IconUsers,
  IconWallet
} from "@tabler/icons-react";
import {RoleEnum} from "./enums/role-enum";

export const acoesSetor: Acao[] = [
  {
    nome: "Novo",
    descricao: "Cadastrar Novo",
    url: "novo",
    icone: IconPlus,
    perfis: [RoleEnum.USUARIO],
    acoes: [
      {
        nome: "Fonte Recurso",
        descricao: "Nova Fonte Recurso",
        url: "novaFonteRecurso",
        icone: IconFolderDollar,
      },
      {
        nome: "Projeto",
        descricao: "Novo Projeto",
        url: "projetos/novoProjeto",
        icone: IconFilePlus,
      },
      {
        nome: "Conta",
        descricao: "Nova Conta",
        url: "novaConta",
        icone: IconWallet,
      },
      {
        nome: "Natureza Despesa",
        descricao: "Nova Natureza Despesa",
        url: "novaNaturezaDespesa",
        icone: IconTag,
      },
      {
        nome: "Concedente",
        descricao: "Novo Concedente",
        url: "novoConcedente",
        icone: IconThumbUp,
      },
      {
        nome: "Convenente",
        descricao: "Novo Convenente",
        url: "novoConvenente",
        icone: IconHandFingerRight,
      }
    ]
  },
  {
    nome: "Listar",
    descricao: "Listar",
    url: "listar",
    icone: IconList,
    perfis: [RoleEnum.ADM],
    acoes: [
      {
        nome: "Projetos Arquivados",
        descricao: "Lista os Projetos Arquivados",
        url: "projetosArquivados/listar",
        icone: IconArchive,
        perfis: [RoleEnum.ADM]
      },
      {
        nome: "Setores",
        descricao: "Lista os Setores",
        url: "setores",
        icone: IconBuilding,
        perfis: [RoleEnum.ADM]
      },
      {
        nome: "Usuários",
        descricao: "Lista os Usuários",
        url: "usuario",
        icone: IconUsers,
        perfis: [RoleEnum.ADM]
      },
      {
        nome: "Forças",
        descricao: "Lista as Forças",
        url: "forca",
        icone: IconShieldFilled,
        perfis: [RoleEnum.ADM]
      },
      {
        nome: "Delegacias",
        descricao: "Nova Delegacia",
        url: "delegacia",
        icone: IconBuildingPlus,
      }
    ]
  }
]
